import dayjs, { Dayjs } from "dayjs"
import dayjs_plugin_utc from "dayjs/plugin/utc"

dayjs.extend(dayjs_plugin_utc)

export const getLastNDaysExcludingToday = (daysCount: number): { startDate: Dayjs; endDate: Dayjs } => {
  const startDate = dayjs().utc().subtract(daysCount, "day").startOf("day")
  const endDate = dayjs().utc().subtract(1, "day").startOf("day")

  return { startDate, endDate }
}

export const getTimeZoneFullText = (timeZone: string) => {
  if (!timeZone) return null

  if (timeZone === "UTC") return "UTC"

  return `${timeZone.replace("_", " ")} UTC ${dayjs()
    .tz(timeZone || "UTC")
    .format("Z")}`
}

export const stringifyDateRange = (dateRange: [Dayjs | null | string, Dayjs | null | string], showLongText = false) => {
  const start = typeof dateRange[0] === "string" ? dateRange[0] : dateRange[0]?.format("YYYY-MM-DD")
  const end = typeof dateRange[1] === "string" ? dateRange[1] : dateRange[1]?.format("YYYY-MM-DD")

  if (start && end && start === end) {
    return start
  }

  if (showLongText && start && end) {
    return `from ${start} to ${end}`
  }

  if (start && end) {
    return `${start} - ${end}`
  }

  if (start) {
    return `from ${start}`
  }

  if (end) {
    return `until ${end}`
  }

  return ""
}
